<template>
  <div style="height: calc(100% - 10px);" v-loading="loading">
    <div class="aff-search nav-list">
      <oaExamineSearchs ref="oaExamineSearch" :styles="informStyle" :stat="stat" :isStatInitiate="isStatInitiate" :isapply="approvalId" :searchTitle="searchTitle" soltStyle="text-align:right;margin-left:400px" @upTotal="getTopDate" @returnSearch="getSearch">
        <a :class="Number(isStatInitiate) === 0 ? 'list initiate-yes' : 'list'" @click="statInitiate(0)">
          未读
          <span class="initiate-number" v-show="infoTotal > 0">{{infoTotal}}</span>
        </a>
        <a :class="Number(isStatInitiate) === 1 ? 'list initiate-yes' : 'list'" @click="statInitiate(1)">已读</a>
      </oaExamineSearchs>
    </div>
    <oaExamineTables @goInfo="goAudit" ref="info" v-show="isStatInitiate === 0" :isMy="true" :initiateArr="info" :isIndex="1" />
    <oaExamineTables @goInfo="goAudit" ref="info1" :isMy="true" v-show="isStatInitiate === 1" :initiateArr="info1" :isIndex="1" />
    <div class="page-bottom">
      <el-pagination class="pagination" :page-size="6" background v-model:current-page="infoPage" @current-change="handleCurrentChange" v-show="isStatInitiate === 0 && infoTotal > 6" layout="prev, pager, next, jumper" :total="infoTotal"/>
      <el-pagination class="pagination" :page-size="6" background v-model:current-page="info1Page" @current-change="handleCurrentChange" v-show="isStatInitiate === 1 && info1Total > 6" layout="prev, pager, next, jumper" :total="info1Total"/>
    </div>
  </div>
</template>

<script>
  import oaExamineTables from '@/views/clientSide/oaExamine/components/oaExamineTable.vue'
  import oaExamineSearchs from '@/views/clientSide/oaExamine/components/oaExamineSearch.vue'
  import { openapiGetuserapprovinglist } from '@/port/clientSide/oaExamine'
  import { openapiGetuserccapprovallist } from '@/port/clientSide/oaExamineAudit'
  import { oaExamineFormdata, stayUserIsItReadFunc } from '@/api/index'

  /**
   * approvalId 应用id，必选参数
   * stat 上级传过来区分状态的 searchTitle 这个值存在参数则表明他是待阅
   * */
  export default {
    name: "affairList",
    components: {
      oaExamineTables,
      oaExamineSearchs
    },
    props:["stat", "searchTitle", "approvalId", "isLeft"],
    data() {
      return{
        info: [],
        info1: [],
        infoTotal: 0,
        info1Total: 0,
        infoPage: 1,
        info1Page: 1,
        query: null,
        url: openapiGetuserapprovinglist,
        informStyle: [
          {
            label: '全部',
            val: '0,1,2,3'
          },
          {
            label: '进行中',
            val: '0'
          },
          {
            label: '已通过',
            val: '1'
          },
          {
            label: '未通过',
            val: '2'
          },
          {
            label: '已撤回',
            val: '3'
          }
        ],  //告知我的状态
        isStatInitiate: 0,
        loading: false
      }
    },
    methods: {
      // 切页
      handleCurrentChange(e) {
        console.log('handleCurrentChange', e);
        this.query.curpage = e;
        if (this.isStatInitiate === 0) {
          this.infoPage = e;
        } else {
          this.info1Page = e;
        }
        this.getList();
      },
      getSearch(e) {
        console.log('getSearch', e);
        // 删掉应用id，其他的数据合并
        delete e.approvalId;
        if (this.query.state || this.query.state === 0) delete this.query.state;
        this.query.curpage = 1;
        this.query.appname = e.appname;
        this.query.startTime = e.startTime || undefined;
        this.query.endTime = e.endTime || undefined;
        if (e.status || e && e.status === 0) this.query.state = e.status;
        this.getList();
      },
      getTopDate() {
        // 全部已读就走一次搜索，并回去刷新一下数据
        this.query.curpage = 1;
        this.info1 = [];
        this.getList();
        this.$emit('referHave')
      },
      goAudit(e) {
        console.log('点击回来的', e);
        // 如果是待阅 并且未读，就判断条件并刷新，并回抛条件去上一级选择打开
        if (this.searchTitle && this.isStatInitiate === 0 && e.isread !== 1) {
          stayUserIsItReadFunc(e);
          // setTimeout(() => {
            this.getList();
          // }, 500);
        }
        this.$emit('retOpen', e);
      },
      // 已读未读切换
      statInitiate(e) {
        console.log('已读未读切换', e);
        if (e === this.isStatInitiate) return false;
        this.isStatInitiate = e;
        this.query.status = e;
        // 已读未读跳页切换
        this.query.curpage = e === 0 ? this.infoPage : this.info1Page;
        if (e === 0 && this.info.length === 0 || e === 1 && this.info1.length === 0) this.getList();
      },
      initialization(query, url) {
        this.query = query;
        if (url === 'ccapproval') this.url = openapiGetuserccapprovallist;
        this.getList();
      },
      getList() {
        this.loading = true;
        const __par = JSON.parse(JSON.stringify(this.query))
        if (this.$route.query.space && localStorage.getItem('spaceid')) __par.spaceid = localStorage.getItem('spaceid')
        else if (this.$route.query.upace && localStorage.getItem('upaceid')) __par.upaceid = localStorage.getItem('upaceid')
        this.url(__par).then(res => {
          if (res.code === 0) {
            res.data.forEach(el => {
              if (el.approving.formdata) {
                el.approvingFormdata = el.approving.formdata
              }
              el = oaExamineFormdata(el);
            })
            let data = this.filterDate(res.data);
            console.log('当前条件', this.isStatInitiate, this.searchTitle)
            if (this.isStatInitiate === 1 && this.searchTitle) {
              this.info1 = data;
              this.info1Total = res.total;
            } else {
              this.info = data;
              this.infoTotal = res.total;
            }
            // 这里检测一次下面的表格高度数据
            let self = this;
            this.$nextTick(function () {
              const str = this.isStatInitiate === 0 && this.searchTitle ? 'info1' : 'info';
              let dom = self.$refs[str];
              if (dom && !dom.heightCount) dom.heightFun();
            })
          }
          this.loading = false;
        }).catch(err => {
          this.loading = false;
          console.log('请求出错', err)
        })
      },
      //过滤值
      filterDate(date) {
        let data = []
        date.forEach((val) => {
          let keyArr = []
          if (val.approving.formdata && val.form) {
            val.approving.formdata.forEach(val => {
              let keys = val.key.split('_')
              if (keys[1] && keys[1] === 'text' || keys[1] === 'name' || keys[1] === 'date' || keys[1] === 'textarea' || keys[1] === 'checkbox' || keys[1] === 'relation-check' || keys[1] === 'number' || keys[1] === 'radio') {
                keyArr.push(val)
              }
            })
            if (keyArr.length > 3) {
              keyArr = keyArr.splice(0,3)
            }
            val.summary = keyArr
          }
          data.push(val)
        })
        return data
      },
    }
  }
</script>

<style lang="scss" scoped>
  .aff-search {
    // box-shadow:0px 1px 6px 0px rgba(0,0,0,0.18);
    border-radius:8px;
  }
  .list {
    display: block;
    line-height: 26px;
    width:66px;
    height:26px;
    border-radius:6px;
    font-size:14px;
    text-align: center;
    color: #666666;
    cursor: pointer;
    position: relative;
    // margin-right: 38px;
  }
  .initiate-yes {
    background: rgba(78, 166, 255, 0.1);
    border: 1px dashed #4e86ff;
    color: #4e86ff;
  }
  .initiate-number {
    display: block;
    min-width: 8px;
    height: 24px;
    line-height: 27px;
    text-align: center;
    // background: $base-base-color;
    font-size: 14px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    color: white;
    border-radius: 12px;
    padding-left: 8px;
    padding-right: 8px;
    position: absolute;
    top: -7px;
    right: -9px;
  }
  .initiate-number::after {
    content: ' ';
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    // border-top: 6px solid $base-base-color;
    position: absolute;
    bottom: -8px;
    left: -2px;
    transform:rotate(28deg)
  }
  .initiate-button {
    width:134px;
    height:36px;
    line-height:36px;
    border-radius:6px;
    border:1px solid rgba(151,151,151,1);
    font-size:16px;
    // color:$base-text-main-color;
    text-align: center;
    cursor: pointer;
  }
  .initiate-button:active {
    // background: $base-border-color;
    color: #FFFFFF;
  }
  .page-bottom {
    position: absolute;
    bottom: 30px;
    text-align: center;
    width: 80%;
  }
</style>
